import { h, type VNodeChild } from 'vue'

import {
  experienceLayoutClasses,
  type ExperienceGridItemProps,
  type ExperienceGridProps,
  type ExperienceStackProps,
  type ExperienceSurfaceProps,
} from '../catalog/experience-layout-definitions'

const className = (classes: readonly string[]) => classes.filter(Boolean).join(' ')

interface LayoutComponentContext<Props> {
  readonly props: Props
  readonly children?: VNodeChild
}

export const EXPERIENCE_LAYOUT_COMPONENTS = {
  Grid: ({ props, children }: LayoutComponentContext<ExperienceGridProps>) =>
    h('div', { class: className(experienceLayoutClasses.grid(props)) }, children ?? []),
  GridItem: ({ props, children }: LayoutComponentContext<ExperienceGridItemProps>) =>
    h('div', { class: className(experienceLayoutClasses.gridItem(props)) }, children ?? []),
  Stack: ({ props, children }: LayoutComponentContext<ExperienceStackProps>) =>
    h('div', { class: className(experienceLayoutClasses.stack(props)) }, children ?? []),
  Surface: ({ props, children }: LayoutComponentContext<ExperienceSurfaceProps>) =>
    h('div', { class: className(experienceLayoutClasses.surface(props)) }, children ?? []),
} as const
